import { IFilters } from "reducer/category.reducer";
import { CUSTOM_SIZES } from "./customSizesConstants";
import { VALID_FILTER_FOR_SUMMARY } from "./filter-constants";

export interface QueryParams extends IFilters {
  make ?: string,
  model?: string,
  year?: string,
  pageNumber?: string,
  ph?: string,
  c?: string,
  sortBy?: string,
  numberOfProducts?: number,
  availability?: any,
  priceRanges?: any,
  postalCode?: string
  url?: string | string[]
  t1?: string,
  t2?: string,
  t3?: string,
  oePartNumber?: string,
  oeMake?: string,
}

export type ValidQueryParams = keyof QueryParams;

export const validQueryParams: ValidQueryParams[] = [
  "make",
  "model",
  "year",
  "pageNumber",
  "ph",
  "c",
  "sortBy",
  "tier1",
  "tier2",
  "tier3",
  "oePartNumber",
  "oeMake",
  ...CUSTOM_SIZES,
  ...VALID_FILTER_FOR_SUMMARY,
];

export const WHITELIST_PARAMS = [
  "make",
  "model",
  "year",
  "tier1",
  "tier2",
  "tier3",
  "pageNumber",
  "manufacturers",
  "sizes",
];

export const API_WHITELIST_PARAMS = [
  "make",
  "model",
  "year",
  "t1", // tier1,  t1 since api need t1 but url have tier1
  "t2", // tier2
  "t3", // tier3
  "pageNumber",
  "manufacturers",
  "sizes",
  "oePartNumber",
  "oeMake",
  ...CUSTOM_SIZES,
];

export const INVALID_BROWSER_QUERY_PARAMS = [
  "selectedMake",
  "selectedModel",
  "selectedYear",
  "engine",
  "postalCode",
  "subModel",
  "trim",
  "fo.name",
  "fo.value",
  "isCSR",
  "locale",
  "businessCustomer",
];
